// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cases-tab-main {
  display: flex;
  justify-content: space-between;
}

.court-tabs-container .court-tabs {
  display: flex;
  gap: 2px;
  background-color: #E2E8F0;
  padding: 4px;
  border-radius: 8px;
  width: fit-content;
}
.court-tabs-container .court-tabs button {
  padding: 8px 18px;
  border: none;
  background: transparent;
  color: #64748b;
  font-weight: 500;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: flex-start;
}
.court-tabs-container .court-tabs button:hover {
  background: rgba(255, 255, 255, 0.8);
  color: #374151;
}
.court-tabs-container .court-tabs button.active {
  background: #ffffff;
  color: #1f2937;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.court-tabs-container .court-tabs button .court-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: crimson;
  color: white;
  font-size: 10px;
  font-weight: bold;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  margin-left: 8px;
  animation: popIn 0.3s ease-in-out;
}
@keyframes popIn {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.case-tabs-container .case-tabs {
  display: flex;
  gap: 2px;
  background: #E2E8F0;
  padding: 4px;
  border-radius: 8px;
  width: fit-content;
}
.case-tabs-container .case-tabs button {
  padding: 8px 18px;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.case-tabs-container .case-tabs button:hover {
  background: rgba(255, 255, 255, 0.8);
  color: #374151;
}
.case-tabs-container .case-tabs button.active {
  background: #ffffff;
  color: #1f2937;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .cases-container {
    padding: 1rem;
  }
  .court-tabs-container .court-tabs,
  .case-tabs-container .case-tabs {
    width: 100%;
  }
  .court-tabs-container .court-tabs button,
  .case-tabs-container .case-tabs button {
    flex: 1 1;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .court-tabs-container .court-tabs button {
    padding: 8px 12px;
    font-size: 12px;
  }
  .case-tabs-container .case-tabs button {
    padding: 6px 10px;
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Cases/Cases.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF;;AAIE;EACE,aAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AADJ;AAGI;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AADN;AAGM;EACE,oCAAA;EACA,cAAA;AADR;AAIM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,wCAAA;AAFR;AAKM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iCAAA;AAHR;AAMM;EACE;IACE,qBAAA;IACA,UAAA;EAJR;EAOM;IACE,mBAAA;IACA,UAAA;EALR;AACF;;AAcE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAXJ;AAaI;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAXN;AAaM;EACE,oCAAA;EACA,cAAA;AAXR;AAcM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,wCAAA;AAZR;;AAmBA;EACE;IACE,aAAA;EAhBF;EAmBA;;IAEE,WAAA;EAjBF;EAmBE;;IACE,SAAA;IACA,kBAAA;EAhBJ;AACF;AAoBA;EACE;IACE,iBAAA;IACA,eAAA;EAlBF;EAqBA;IACE,iBAAA;IACA,eAAA;EAnBF;AACF","sourcesContent":[".cases-tab-main {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.court-tabs-container {\r\n\r\n  .court-tabs {\r\n    display: flex;\r\n    gap: 2px;\r\n    background-color: #E2E8F0;\r\n    padding: 4px;\r\n    border-radius: 8px;\r\n    width: fit-content;\r\n\r\n    button {\r\n      padding: 8px 18px;\r\n      border: none;\r\n      background: transparent;\r\n      color: #64748b;\r\n      font-weight: 500;\r\n      font-size: 14px;\r\n      border-radius: 6px;\r\n      cursor: pointer;\r\n      transition: all 0.2s ease;\r\n      display: flex;\r\n      align-items: flex-start;\r\n\r\n      &:hover {\r\n        background: rgba(255, 255, 255, 0.8);\r\n        color: #374151;\r\n      }\r\n\r\n      &.active {\r\n        background: #ffffff;\r\n        color: #1f2937;\r\n        font-weight: 600;\r\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n      }\r\n\r\n      .court-badge {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        background-color: crimson;\r\n        color: white;\r\n        font-size: 10px;\r\n        font-weight: bold;\r\n        border-radius: 50%;\r\n        width: 17px;\r\n        height: 17px;\r\n        margin-left: 8px;\r\n        animation: popIn 0.3s ease-in-out;\r\n      }\r\n\r\n      @keyframes popIn {\r\n        0% {\r\n          transform: scale(0.5);\r\n          opacity: 0;\r\n        }\r\n\r\n        100% {\r\n          transform: scale(1);\r\n          opacity: 1;\r\n        }\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n.case-tabs-container {\r\n\r\n  .case-tabs {\r\n    display: flex;\r\n    gap: 2px;\r\n    background: #E2E8F0;\r\n    padding: 4px;\r\n    border-radius: 8px;\r\n    width: fit-content;\r\n\r\n    button {\r\n      padding: 8px 18px;\r\n      border: none;\r\n      background: transparent;\r\n      color: #6b7280;\r\n      font-weight: 500;\r\n      font-size: 13px;\r\n      border-radius: 6px;\r\n      cursor: pointer;\r\n      transition: all 0.2s ease;\r\n\r\n      &:hover {\r\n        background: rgba(255, 255, 255, 0.8);\r\n        color: #374151;\r\n      }\r\n\r\n      &.active {\r\n        background: #ffffff;\r\n        color: #1f2937;\r\n        font-weight: 600;\r\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive Design\r\n@media (max-width: 768px) {\r\n  .cases-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .court-tabs-container .court-tabs,\r\n  .case-tabs-container .case-tabs {\r\n    width: 100%;\r\n\r\n    button {\r\n      flex: 1;\r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .court-tabs-container .court-tabs button {\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .case-tabs-container .case-tabs button {\r\n    padding: 6px 10px;\r\n    font-size: 11px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
